export const ObjectIcons = {
  dashboard: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M3 3h8v8H3V3Zm0 10h8v8H3v-8Zm10-10h8v4h-8V3Zm0 6h8v12h-8V9Z"
      />
    </svg>
  ),
  findings: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm6 1.5V9h4.5L13 4.5ZM8 12h8v1.5H8V12Zm0 4h8v1.5H8V16Z"
      />
    </svg>
  ),
  projects: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M4 7.5 12 3l8 4.5-8 4.5-8-4.5Zm0 3.5 8 4.5 8-4.5V18l-8 4-8-4v-7Z"
      />
    </svg>
  ),
  pipelines: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M5 4h5v5H5V4Zm9 0h5v5h-5V4ZM5 15h5v5H5v-5Zm9 0h5v5h-5v-5ZM7.5 9.5h9v5h-9v-5Z"
      />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M5 4h2V2h1.5v2h7V2H17v2h2a2 2 0 0 1 2 2v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a2 2 0 0 1 2-2Zm14 6H5v8.5h14V10ZM5 8.5h14V6H17v1.5h-1.5V6h-7v1.5H7V6H5v2.5Z"
      />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.75.75 0 0 0 .18-.96l-1.92-3.32a.75.75 0 0 0-.92-.33l-2.39.96a7.06 7.06 0 0 0-1.62-.94l-.36-2.54a.75.75 0 0 0-.74-.64h-3.84a.75.75 0 0 0-.74.64l-.36 2.54c-.57.23-1.12.54-1.62.94l-2.39-.96a.75.75 0 0 0-.92.33L2.65 7.52a.75.75 0 0 0 .18.96l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58a.75.75 0 0 0-.18.96l1.92 3.32c.2.35.62.5.98.35l2.39-.96c.5.4 1.05.71 1.62.94l.36 2.54c.06.37.37.64.74.64h3.84c.37 0 .68-.27.74-.64l.36-2.54c.57-.23 1.12-.54 1.62-.94l2.39.96c.36.15.78 0 .98-.35l1.92-3.32a.75.75 0 0 0-.18-.96l-2.03-1.58ZM12 15.5a3.5 3.5 0 1 1 0-7a3.5 3.5 0 0 1 0 7Z"
      />
    </svg>
  ),
  integrations: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7 2h10a2 2 0 0 1 2 2v1H5V4a2 2 0 0 1 2-2ZM3 7h18v2H3V7Zm2 4h14v9a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-9Zm4 2v2h6v-2H9Zm0 4v2h4v-2H9Z"
      />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-3.33 0-8 1.67-8 5v2h16v-2c0-3.33-4.67-5-8-5Zm7.5-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0-1.7.44c.75.96 1.2 2.17 1.2 3.56s-.45 2.6-1.2 3.56c.53.28 1.1.44 1.7.44Zm.94 1.2c2.42.68 4.56 2.15 4.56 4.8v2h-4v-2c0-1.85-.78-3.4-2.06-4.56.5-.16 1-.24 1.5-.24Z"
      />
    </svg>
  ),
} as const;
